// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import { Button } from 'ui'
import QualCodeActions from 'actions/QualCodeActions'
import AuthStore from 'stores/AuthStore'
import DelveAccountBody from './DelveAccountBody'
import FieldGroup from './FieldGroup'
import DimensionsConstants from 'constants/DimensionsConstants'
import { PASSWORD_RESET_MESSAGE, EMAIL_CONFIRMED_MESSAGE } from '../../constants/LoginDisplayConstants';

const queryString = require('query-string');

class LoginDisplay extends React.Component {
  constructor () {
    super();
    this.onEmailChange = this.onEmailChange.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onMfaCodeChange = this.onMfaCodeChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this._onChange = this._onChange.bind(this);
    this.removeQueryParams = this.removeQueryParams.bind(this);
    this.state = {
      cachedEmail: null,
      email: "",
      password: "",
      mfaCode: "",
      ...AuthStore.getLoginState(),
    }
  }

  static getDerivedStateFromProps(nextProps, prevState)
  {
    const parsed = queryString.parse(nextProps.location.search);
    const email = parsed.email;

    if ( email && email != prevState.cachedEmail)
    {
      return {
        ...prevState,
        cachedEmail: email,
        email: email
      }
    }
    return null;
  }

  _onChange () {
    const loginState = AuthStore.getLoginState();

    // Once MFA is required, keep it set to true (don't allow rollback to false)
    const mfaRequired = this.state.mfaRequired || loginState.mfaRequired;
    const mfaEmail = this.state.mfaEmail || loginState.mfaEmail;

    // Clear password when MFA screen is shown (user must re-enter it)
    if (mfaRequired && !this.state.mfaRequired) {
      this.setState({
        ...loginState,
        mfaRequired: true,
        mfaEmail,
        password: "",
        mfaCode: ""
      });
    } else {
      this.setState({
        ...loginState,
        mfaRequired,
        mfaEmail
      });
    }
  }

  componentDidMount () {
    AuthStore.addChangeListener(this._onChange);
  }

  componentWillUnmount () {
    AuthStore.removeChangeListener(this._onChange);
  }

  onSubmit(e)
  {
    this.removeQueryParams(['reset', 'email_confirmed']);
    const email = this.state.mfaRequired ? this.state.mfaEmail : this.state.email;
    QualCodeActions.signIn(email, this.state.password, this.state.mfaCode || null);
    e.preventDefault()
  }

  onEmailChange (e) {
    this.setState({
      email: e.target.value
    });
  }

  onPasswordChange (e) {
    this.setState({
      password: e.target.value
    })
  }

  onMfaCodeChange (e) {
    this.setState({
      mfaCode: e.target.value
    })
  }

  removeQueryParams(paramNames) {
    const searchParams = new URLSearchParams(this.props.location.search);
    paramNames.forEach(name => searchParams.delete(name));
    this.props.history.replace({
      pathname: this.props.location.pathname,
      search: searchParams.toString(),
    });
  }

  renderMfaForm() {
    return (
      <DelveAccountBody
        error={this.state.error.show ? {message:this.state.error.message, error:true} : {}}
        subHeader="2 Step Verification"
      >
        <div style={{width:DimensionsConstants.ACCOUNT_WIDTH, margin: "0 auto"}}>
          <p style={{marginBottom: "20px", color: "#666"}}>
            Please enter the 6-digit code from your authenticator app
          </p>
          <form onSubmit={this.onSubmit} autoComplete="on">
            <FieldGroup
              id="formControlsPassword"
              label="Password"
              type="password"
              name="password"
              onChange={this.onPasswordChange}
              value={this.state.password}
              autoComplete="current-password"
              placeholder="Enter password"
              autoFocus
            />
            <FieldGroup
              id="formControlsMfaCode"
              type="text"
              name="mfaCode"
              label="6 digit verification code"
              value={this.state.mfaCode}
              onChange={this.onMfaCodeChange}
              autoComplete="one-time-code"
              placeholder="Enter 6 digit verification code"
            />

            <div style={{width: "100%", marginTop:"30px"}}>
              <div style={{width: DimensionsConstants.ACCOUNT_WIDTH, margin: "0 auto"}}>
                <Button variant="blue" type="submit" style={{width:"100%"}}>Verify</Button>
              </div>
            </div>
          </form>
        </div>
      </DelveAccountBody>
    );
  }

  renderLoginForm() {
    const shouldShowPasswordResetMessage = this.props.location.search.includes('reset=true')
    const shouldShowEmailConfirmedMessage = this.props.location.search.includes('email_confirmed=true')
    const successMessage = shouldShowPasswordResetMessage
      ? { message: PASSWORD_RESET_MESSAGE }
      : shouldShowEmailConfirmedMessage
        ? { message: EMAIL_CONFIRMED_MESSAGE }
        : this.state.success;
    return (
      <DelveAccountBody
        error={this.state.error.show ? {message:this.state.error.message, error:true} : {}}
        subHeader="Log In"
        success={successMessage}
        reset
        signUp={SIGN_UP_FLAG}
      >
        <div style={{width:DimensionsConstants.ACCOUNT_WIDTH, margin: "0 auto"}}>
          <form onSubmit={this.onSubmit} autoComplete="on">
            <FieldGroup
              id="formControlsEmail"
              type="email"
              name="email"
              label="Email address"
              value={this.state.email}
              onChange={this.onEmailChange}
              autoComplete="username email"
              placeholder="Enter email"
            />
            <FieldGroup
              id="formControlsPassword"
              label="Password"
              type="password"
              name="password"
              onChange={this.onPasswordChange}
              value={this.state.password}
              autoComplete="current-password"
              placeholder="Enter password"
            />

            <div style={{width: "100%", marginTop:"30px"}}>
              <div style={{width: DimensionsConstants.ACCOUNT_WIDTH, margin: "0 auto"}}>
                <Button variant="blue" type="submit" style={{width:"100%"}}>Log In</Button>
              </div>
            </div>
          </form>
        </div>
      </DelveAccountBody>
    );
  }

  render () {
    if (this.state.mfaRequired) {
      return this.renderMfaForm();
    }
    return this.renderLoginForm();
  }
}

export default LoginDisplay;